import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

// Zippedi tools reducer
import { snackAlertReducer } from '@zippeditoolsjs/blocks';
import { storeWalkReducer, tourImageReducer } from '@zippeditoolsjs/virtual-store-walk';

import { reducer as backendReducer } from './slices/backend';
import { reducer as brunoReducer } from './slices/bruno';
import { reducer as clientsReducer } from './slices/clients';
import { reducer as contactsReducer } from './slices/contacts';
import { reducer as dashboardsReducer } from './slices/dashboards';
import { reducer as digitalStoreReducer } from './slices/digitalStore';
import { reducer as documentationReducer } from './slices/documentation';
import { reducer as generalReduer } from './slices/general';
import { reducer as linkReducer } from './slices/link';
import { reducer as notificationsReducer } from './slices/notifications';
import { reducer as productsReducer } from './slices/products';
import { reducer as producsStatesReducer } from './slices/productsStates';
import { reducer as sessionReducer } from './slices/session';
import { reducer as storesReducer } from './slices/store';
import { reducer as suppliersReducer } from './slices/suppliers';
import { reducer as tasksReducer } from './slices/tasks';
import { reducer as trackingListReducer } from './slices/trackingList';
import { reducer as translationsReducer } from './slices/translations';
import { reducer as userReducer } from './slices/users';
import { reducer as wallsReducer } from './slices/wall';

export default function _createStore(services) {
  return createStore(
    combineReducers({
      backend: backendReducer,
      bruno: brunoReducer,
      clients: clientsReducer,
      contacts: contactsReducer,
      dashboards: dashboardsReducer,
      digitalStore: digitalStoreReducer,
      documentation: documentationReducer,
      general: generalReduer,
      link: linkReducer,
      notifications: notificationsReducer,
      products: productsReducer,
      productsStates: producsStatesReducer,
      session: sessionReducer,
      snackAlert: snackAlertReducer,
      store: storesReducer,
      suppliers: suppliersReducer,
      tasks: tasksReducer,
      trackingList: trackingListReducer,
      translations: translationsReducer,
      user: userReducer,
      wall: wallsReducer,
      storeWalk: storeWalkReducer,
      imageTour: tourImageReducer,
    }),
    applyMiddleware(thunk.withExtraArgument({ services })),
  );
}
